export const fieldOptions = [
    {
        name: '',
        fa_name: 'لطفا انتخاب کنید',
        value: null,
    },
    {
        name: 'optional',
        fa_name: 'اختیاری',
        value: 1,
    },
    {
        name: 'required',
        fa_name: 'اجباری',
        value: 2,
    }
]


export const fieldOptionsConstants = {
    OPTIONAL: 1,
    REQUIRED: 2,

    get(option) {
        let option_str = null;

        Object.keys(fieldOptions).forEach(item => {
            if (fieldOptions[item].name === option) {
                option_str = fieldOptions[item].fa_name;
            }
        });

        return option_str;
    }
}